import EntitiesFilter from './entitiesFilter.vue';
import Loader from './loader.vue';
import Table from './table.vue';
import Footer from './footer.vue';
import Button from "./button.vue";
import Notification from "./notification.vue";
import {default as trueAxion} from 'axios';

export const App = {
    name: "App",
    components: { EntitiesFilter, Loader, Table, Footer, Button, Notification },
    props: {
        messageId: {
            type: [Number, String],
            required: true,
        },
        endpointUrl: {
            type: String,
            required: true,
        },
        langPack: {
            type: Object,
            required: false,
            default: function() {
                return {};
            }
        },
        imageUrl: {
            type: String,
            required: false,
            default: "https://sandbox.endlichzuhause.com/bitrix/components/godigitalsoftware/emailbinder/templates/.default/assets/logo.png",
        }
    },
    computed: {
        ifSelected() {
            return Object.entries(this.selectedEntities).length;
        }
    },
    data() {
        return {
            testTitle: 'asdasdasdasd', 
            entities: [],
            selectedEntities: {},
            typeNames: {
                0: { title: "Undefined" },
                1: { title: "Lead", color: "orange", TypeName: "Lead" },
                2: { title: "Auftrag", color: "green", TypeName: "Deal" },
                3: { title: "Kontakt", color: "blue", TypeName: "Contact" },
                4: { title: "Unternehmen", color: "yellow", TypeName: "Company" },
                5: { title: "Rechnung", TypeName: "Invoice" },
                6: { title: "Activity" },
                7: { title: "Quote", color: "darkblue", TypeName: "Deal" },
                8: { title: "Requisite" },
                9: { title: "DealCategory" },
                10: { title: "System" },
                "default": { title: "SmartProcess", color: "default", TypeName: "SmartProcess" },
            },
            footerLinks: [
                {
                    title: "Fehler melden",
                    link: "https://formular.go-digital-software.de/bitrix24-module-fehler-melden/",
                    target: "_blank"
                },
                {
                    title: "Verbesserungsvorschlag senden",
                    link: "https://formular.go-digital-software.de/b24-modul-idee/",
                    target: "_blank"
                }
            ],
            isTableBlockVisible: false,
            isErrorBlockVisible: false,
            isLoading: false,
        };
    },
    methods: {
        GetImageUrl() {
            return this.imageUrl;
        },
        GetModuleTitle() {
            return this.langPack["COMPONENT_JS_MAIN_TITLE"] || "E-Mail im CRM speichern";
        },
        GetErrorBlockContent() {
            return this.langPack["COMPONENT_ERROR_BLOCL_CONTENT"] || "There is no entities for display";
        },
        GetGridLangTitles() {
            return {
                ID: this.langPack["COMPONENT_JS_GRID_ID"] || "Id",
                TITLE: this.langPack["COMPONENT_JS_GRID_TITLE"] || "Entity title",
                TYPE: this.langPack["COMPONENT_JS_GRID_TYPE"] || "Entity type",
                URL: this.langPack["COMPONENT_JS_GRID_URL"] || "URL",
                VIEW: this.langPack["COMPONENT_JS_GRID_VIEW"] || "View",
            };
        },
        GetBindTitle() {
            return this.langPack["COMPONENT_JS_BIND"] || "Bind";
        },
        GetExitTitle() {
            return this.langPack["COMPONENT_JS_EXIT"] || "Exit";
        },
        CloseSidePanel() {
            BX.SidePanel.Instance.close();
        },
        BindMessageToEntities() {
            let postEntities = Object.values(this.selectedEntities);
            let response = trueAxion.post(this.endpointUrl, {
                messageid: this.messageId,
                entities: postEntities,
                method: "bind",
            });
            response.then((res) => {
                const resData = res.data;
                let backup = [...this.entities];
                this.entities = [];
                let postEntities = Object.values(this.selectedEntities);
                if (postEntities.length > 0) {
                    let $rows = $('tr[data-id^="' + this.messageId + '"]');
                    if (!$rows.length) {
                        $rows = $('iframe').contents().find('tr[data-id^="' + this.messageId + '"]');
                    }
                    const crmButton = $rows[0].querySelector('.mail-binding-crm.mail-ui-not-active');
                    if (crmButton) {
                        crmButton.setActive(postEntities[0]['URL']);
                    }
                }
                resData.forEach(element => {
                    const index = backup.findIndex(entity => {
                        return (entity.ID == element.ID) && (entity.TYPE == element.TYPE);
                    });
                    if (index > -1) {
                        backup[index] = { BINDED: true, ...backup[index] };
                    }
                });
                this.$nextTick(() => {
                    this.entities = backup;
                });
                this.selectedEntities = [];
            });
        },

        async GetEntitiesFromEndPoint( filterModel ) {
            const payload = {
                ID: filterModel.id,
                TITLE: filterModel.name,
                method: "select",
            };
            this.isLoading = true;
            trueAxion({
                method: 'post',
                url: this.endpointUrl,
                data: payload,
            }).then((data) => {
                this.entities = [...data.data];
                this.selectedEntities = [];
                this.isTableBlockVisible = this.entities.length > 0;
                this.isErrorBlockVisible = this.entities.length <= 0;
            }).finally(() => {
                this.isLoading = false;
            });
        },
    },
    template: `
    <div class="container">
        <div class="header">
            <div class="header__container">
                <h3 class="header__title">
                    {{ GetModuleTitle() }}
                </h3>
                <EntitiesFilter
                    :lang-pack="langPack"
                    @search="GetEntitiesFromEndPoint($event)"
                />
            </div>

            <div class="header__img-wrap">
                <img
                    :src="GetImageUrl()"
                    width="120"
                    height="70"
                    class="header__img"
                >
            </div>
        </div>

        <Notification
            v-if="isErrorBlockVisible"
            :message="GetErrorBlockContent()"
        />

        <Loader v-if="isLoading" />

        <Table
            v-if="isTableBlockVisible"
            v-model="selectedEntities"
            :type-names="typeNames"
            :entities="entities"
            :lang-pack="langPack" 
        >
            123
        </Table>

        <Footer
            :footer-links="footerLinks"
        >
            <Button
                :value="GetExitTitle()"
                class="btn--exit" 
                @click="CloseSidePanel"
            />
            <Button
                v-if="ifSelected"
                :value="GetBindTitle()"
                @click="BindMessageToEntities" 
            />
        </Footer>
    </div>
    `
};